import {FixedSizeList} from 'react-window';
import { useState, useEffect} from 'react';

function OptimizedMenuList(props) {
    const {options, children, maxHeight, getValue} = props;
    let [listHeight, setListHeight] = useState(maxHeight);

    useEffect(() => {
        if ((children.length * height) < maxHeight) {
            setListHeight(children.length*height);
        } else {
            setListHeight(maxHeight);
        }
    }, [maxHeight, children])
    if (!children || !Array.isArray(children)) return null;
    const height = 35;
    const initialOffset = 0;

    return (
       <FixedSizeList
       width={''}
       itemSize={height}
       height ={listHeight}
       itemCount={children.length}
       initialScrollOffset={initialOffset}>
            {({index,style}) => (
                <div className="option-wrapper" style={style}>
                    {children[index]}
                </div>
            )}
       </FixedSizeList>
    );
}

export default OptimizedMenuList;